import React, { Component } from 'react';
import { Icon, Tooltip, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { DialogWrapper } from 'components/DialogWrapper';
import PrescreenAnswers from 'containers/Manage-Questionnaire/prescreen/PrescreenAnswers';
import PrescreenEditQuestionDrawer from 'containers/Manage-Questionnaire/prescreen/PrescreenEditQuestionDrawer';
import { AppToaster } from 'components/AppToaster';
import { archivePrescreenQuestion } from 'api/prescreen';
import { Container } from 'components/styled-components';
import {
  Wrapper,
  Title,
  Controls,
  TitleWrapper,
  Status,
  StatusLabel,
  StatusValue,
} from 'containers/Manage-Questionnaire/styled-components';
import { statusByVersionStatus } from 'utils/functions';
import colors from 'utils/colors';
import { shouldBold } from 'utils/functions';

class PrescreenTableRow extends Component {
  state = { isOpen: false, removeOpen: false };

  openDrawer = () => {
    this.setState({ isOpen: true });
    this.props.setPrescreenIndex(this.props.index);
  };
  closeDrawer = () => {
    this.setState({ isOpen: false });
    this.props.setPrescreenIndex(null);
  };

  openRemoveDialog = () => this.setState({ removeOpen: true });
  handleDismissRemove = () => this.setState({ removeOpen: false });

  handleArchiveQuestion = () => {
    const { question } = this.props;
    archivePrescreenQuestion(question.questionID, question.versionStatus)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        this.props.fetchQuestions();
        this.handleDismissRemove();
        this.closeDrawer();
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  render() {
    const { question, searchQuery } = this.props;
    const status = statusByVersionStatus(question.versionStatus);

    return (
      <Container background={colors.whiteGray} width="95%">
        <Wrapper>
          <TitleWrapper>
            <Title>{shouldBold(question.question, searchQuery)}</Title>
            <Status>
              <StatusLabel>QUESTION ID:</StatusLabel>{' '}
              <StatusValue>{question.questionID}</StatusValue>
            </Status>

            <Controls width="13rem">
              <Status>
                <StatusLabel>STATUS:</StatusLabel>
                <StatusValue>{question.versionStatus}</StatusValue>
              </Status>
              <Tooltip content="Edit">
                <Icon
                  icon={IconNames.EDIT}
                  onClick={this.openDrawer}
                  style={{ cursor: 'pointer' }}
                />
              </Tooltip>
              <Tooltip content={status.getStatus}>
                <Icon
                  icon={status.getIcon}
                  onClick={this.openRemoveDialog}
                  style={{ cursor: 'pointer' }}
                />
              </Tooltip>

              <DialogWrapper
                isOpen={this.state.removeOpen}
                onClose={this.handleDismissRemove}
                title={status.getTitle}
                body={status.getBody}
                confirm={status.getConfirm}
                action={this.handleArchiveQuestion}
              />
            </Controls>
          </TitleWrapper>
          <PrescreenAnswers
            answers={question.answers}
            openParent={this.openDrawer}
            isParentOpen={this.state.isOpen}
            question={question}
            fetchPrescreenQuestions={this.props.fetchQuestions}
            categories={this.props.categories}
            filter={this.props.filter}
            filterField={this.props.filterField}
            searchQuery={searchQuery}
          />
        </Wrapper>
        <PrescreenEditQuestionDrawer
          isOpen={this.state.isOpen}
          question={question}
          closeDrawer={this.closeDrawer}
          openParent={this.openDrawer}
          isParentOpen={this.state.isOpen}
          setPrescreenIndex={this.props.setPrescreenIndex}
          index={this.props.index}
          currentIndex={this.props.currentIndex}
          total={this.props.total}
          fetchPrescreenQuestions={this.props.fetchQuestions}
          categories={this.props.categories}
        />
      </Container>
    );
  }
}

export default PrescreenTableRow;
